import { render, staticRenderFns } from "./ForgottenPsw.vue?vue&type=template&id=3dbb4c1d"
import script from "./ForgottenPsw.vue?vue&type=script&lang=js"
export * from "./ForgottenPsw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports